import React, { useState, useEffect, useContext } from 'react';
import SegregationModuleForm from './SegregationModuleForm';
import NavBar from './NavBar';

import configAdmin from './admin/configAdmin.json';
import { getPageContent } from './admin/apiCalls';
import LoadingSpinner from './LoadingSpinner';
import {Accordion} from "react-bootstrap";
import { store, StateProvider } from '../Store';

const { SEGREGATIONPAGE_CODE } = configAdmin;

export default function SegregationModule() {

  const { state, dispatch } = useContext(store);
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;
  
  const [textContent, setTextContent] = useState({});
  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));

  useEffect(() => {
    getPageContent(setTextContent, SEGREGATIONPAGE_CODE);
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  }, []);

  const styleTheme = {
    'accordion': `${configData?.theme && configData.theme}-odisea-page-content-more`,
  }

  const pageContent = (
    <>
    <div className="odisea-page-content odisea-page-content-flex">
      <div className="odisea-page-content-form">
        <SegregationModuleForm />
      </div>
      <div className="odisea-page-content odisea-page-content-flex">
      <div className={ "odisea-page-content-more " + styleTheme.accordion}>
        <h3>Segregación</h3>
        <div className="odisea-parent">
          <div className="odisea-child1">
          <Accordion defaultActiveKey={['0']} alwaysOpen>
            <Accordion.Item className="odisea-form-accordion-item" eventKey="2">
              <Accordion.Header className="odisea-form-accordion-header">Más información*</Accordion.Header>
              <Accordion.Body>
                <h3>{textContent.title}</h3>
                <p><div dangerouslySetInnerHTML={{__html: textContent.content}} /></p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          </div>
        </div>
        </div>
      </div>
    </div>
    </>
  )

  return (
    <>
      <NavBar />
      {Object.keys(textContent).length > 0 ? pageContent : <LoadingSpinner />}
    </>
  )
}
